(function() {
    'use strict';

    searchService.$inject = ['$http', '$q'];
    angular
        .module('app.search')
        .factory('searchService', searchService);

    /* @ngInject */
    function searchService($http, $q) {
        var service = {
            search: search
        };

        return service;

        function search(pageId, term, pageNumber) {
            return $http.get('/umbraco/api/search/search?pageId=' + pageId +'&term=' +term +'&pageNumber=' + pageNumber) 
                .then(function (response) {
                    if (response.data) {
                        return response.data;
                    }
                    return null;
                });
        };
    }
})();